<!-- 作业 -->
<template>
    <div>
      <div class="course_Homework">
        <el-row class="content_block">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 570px;overflow: auto;">
            <el-tab-pane label="课堂小测" name="HOMEWORK_QUESTION">
              <el-row class="mb10 ct_head">
                <div class="ct_tools">
                  <el-button type="primary" icon="el-icon-plus" @click="addHomeworkInfo">新增</el-button>
                  <el-button type="success" icon="el-icon-printer" @click="exportInfo('HOMEWORK_QUESTION')">导出</el-button>
                </div>
                <div class="ct_stat">
                  <span class="ct_title">小测数据统计：</span>
                  <span class="ct_item" title="应考人数按课程学生总数统计，已考/及格按学生去重">应考人数<b>{{classTest.shouldCount}}</b></span>
                  <span class="ct_item ct_warn">未考人数<b>{{classTest.absentCount}}</b></span>
                  <span class="ct_item ct_blue">已考人数<b>{{classTest.attendedCount}}</b></span>
                  <span class="ct_item ct_green">及格人数<b>{{classTest.passCount}}</b></span>
                  <span class="ct_item ct_red">及格率<b>{{classTest.passRate}}%</b></span>
                  <span class="ct_loading" v-if="classTest.loading">
                    <i class="el-icon-loading"></i> 统计中{{classTest.progress ? '（' + classTest.progress + '）' : '…'}}
                  </span>
                </div>
                <div class="ct_overview">
                  <el-button type="primary" icon="el-icon-data-analysis" plain @click="openOverview">学生小测概览</el-button>
                </div>
              </el-row>
              <el-row>
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%">
                  <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="题库作业名称"> </el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingSchoolClassNames" header-align="center" align="center" label="作业班级"> </el-table-column>
                  <el-table-column prop="avgScore" header-align="center" align="center" label="平均得分"  width="100"> </el-table-column>
                  <el-table-column prop="avgPassRate" header-align="center" align="center" label="及格率"  width="100">
                    <template slot-scope="scope">
                        {{scope.row.avgPassRate || 0}} %
                    </template>
                  </el-table-column>
                  <el-table-column prop="time_" header-align="center" align="center" label="作业时间">
                    <template slot-scope="scope">
                        {{scope.row.teacherOpenCourseQuestionStartTime}} ~ {{scope.row.teacherOpenCourseQuestionEndTime}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingPushStatusText" header-align="center" align="center" label="状态" width="120">
                    <template slot-scope="scope">
                      <span :class="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?'':'red'">
                        {{scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?"发布":"未发布"}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="360" class-name="op_cell">
                    <template slot-scope="scope">
                      <template v-if="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'UN_PUSH'">
                        <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="releaseInfo(scope.row,'PUSH')">发布</el-link>
                      </template>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="editHomeworkInfo(scope.row)">编辑</el-link>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="delInfo(scope.row)">删除</el-link>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="homeworkScore(scope.row)">作业成绩</el-link>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="exportHomeworkScore(scope.row)">导出成绩</el-link>
                      <el-link type="primary" :underline="false" @click="homeworkDetails(scope.row)">作业详情</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[8, 20, 50, 100]"
                    :page-size="limit"
                    background
                    :hide-on-single-page="false"
                    layout="sizes, prev, pager, next,jumper"
                    :total="total">
                  </el-pagination>
                </div>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="作业管理" name="HOMEWORK_FILE">
              <el-row class="mb10">
                <el-button type="primary" icon="el-icon-plus" @click="addHomeworkEnclosure">新增</el-button>
                <el-button type="success" icon="el-icon-printer" @click="exportInfo('HOMEWORK_FILE')">导出</el-button>
                <el-button type="warning" icon="el-icon-data-line" plain @click="openAvgTrend">作业平均分走势图</el-button>
                <label class="ml30">作业汇总：【合计平均得分：{{Number(fileAnalysisInfo.avgStudentScore || 0).toFixed(2)}}；合计及格率：{{Number(fileAnalysisInfo.avgQuestionLogSummaryIsPass || 0).toFixed(2)}} %】</label>
              </el-row>
              <el-row>
                <el-table
                  :data="tableData_file"
                  border
                  style="width: 100%">
                  <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="题库作业名称"> </el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingSchoolClassNames" header-align="center" align="center" label="作业班级/小组">
                    <template slot-scope="scope">
                      <template v-if="scope.row.teacherOpenCourseQuestionSettingPushType == 'GROUP'">
                        <el-tag type="warning" size="small" effect="plain" style="margin-right: 6px;">小组</el-tag>
                        <span>{{ groupNamesText(scope.row) }}</span>
                      </template>
                      <template v-else>
                        {{scope.row.teacherOpenCourseQuestionSettingSchoolClassNames}}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="messageAddTime" header-align="center" align="center" label="作业附件" width="120">
                    <template slot-scope="scope">
                      <template v-if="!$isEmpty(scope.row.teacherOpenCourseQuestionSettingFile)">
                        <el-link type="primary" @click="downLoadInfo(scope.row)" :underline="false" >下载</el-link>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="avgScore" header-align="center" align="center" label="平均得分"  width="100"> </el-table-column>
                  <el-table-column prop="avgPassRate" header-align="center" align="center" label="及格率"  width="100">
                    <template slot-scope="scope">
                        {{scope.row.avgPassRate || 0}} %
                    </template>
                  </el-table-column>
                  <el-table-column prop="time_" header-align="center" align="center" label="作业时间">
                    <template slot-scope="scope">
                        {{scope.row.teacherOpenCourseQuestionStartTime}} ~ {{scope.row.teacherOpenCourseQuestionEndTime}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="teacherOpenCourseQuestionSettingPushStatusText" header-align="center" align="center" label="状态" width="120">
                    <template slot-scope="scope">
                      <span :class="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?'':'red'">
                        {{scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?"发布":"未发布"}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="340" class-name="op_cell">
                    <template slot-scope="scope">
                      <template v-if="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'UN_PUSH'">
                        <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="releaseInfo(scope.row,'PUSH')">发布</el-link>
                      </template>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="addHomeworkEnclosure(scope.row)">编辑</el-link>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="delInfo(scope.row)">删除</el-link>
                      <template v-if="scope.row.teacherOpenCourseQuestionSettingPushStatus != 'UN_PUSH'">
                        <el-link type="primary" :underline="false" class="mr10" @click="practicalReview(scope.row)">评阅</el-link>
                      </template>
                      <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="exportHomeworkFile(scope.row)">导出作业</el-link>
                      <el-link type="primary" :underline="false" @click="HomeworkFJScore(scope.row)">作业详情</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                  <el-pagination
                    @size-change="handleSizeChange_file"
                    @current-change="handleCurrentChange_file"
                    :current-page.sync="currentPage1_file"
                    :page-sizes="[8, 20, 50, 100]"
                    :page-size="limit_file"
                    background
                    :hide-on-single-page="false"
                    layout="sizes, prev, pager, next,jumper"
                    :total="total_file">
                  </el-pagination>
                </div>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-row>

        <!-- 添加附件作业 -->
        <el-dialog
          title="附件作业"
          :visible.sync="homewordk_dialog"
          class="dialog_"
          width="700px">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="作业名称：">
               <el-input v-model="form.teacherOpenCourseQuestionSettingName" placeholder="请输入作业名称"></el-input>
            </el-form-item>
            <el-form-item label="发布方式：">
              <el-radio-group v-model="pushType" @change="onPushTypeChange">
                <el-radio label="CLASS">按班级发布</el-radio>
                <el-radio label="GROUP">按小组发布</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="作业班级：" v-if="pushType == 'CLASS'">
              <el-select v-model="classIds" style="width: 100%;" clearable multiple collapse-tags filterable placeholder="请选择">
                <template v-for="(item ,index) in classList">
                  <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="作业小组：" v-if="pushType == 'GROUP'">
              <el-select v-model="groupIds" style="width: 100%;" clearable multiple collapse-tags placeholder="请选择小组">
                <template v-for="(item ,index) in courseGroups">
                  <el-option :label="item.name + '（' + (item.studentIds ? item.studentIds.length : 0) + '人）'" :value="item.groupId || item.name"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="作业时间：">
              <el-date-picker
                v-model="time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="作业要求：">
              <el-input type="textarea" :rows="4" v-model="form.teacherOpenCourseQuestionSettingRequire"></el-input>
            </el-form-item>
            <el-form-item label="作业附件：">
              <UploadFiles
                ref="taskPicture"
                :limit="1"
                :isPdf="false"
                :fileLists="teacherOpenCourseQuestionSettingFileList"
                v-if="homewordk_dialog"
                @onSuccess="infoSuccess"
              />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="homewordk_dialog = false">取 消</el-button>
            <el-button type="primary" @click="submitHomewordk">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 作业平均分走势图 -->
        <el-dialog
          title="作业平均分走势图"
          :visible.sync="avgTrendShow"
          class="dialog_"
          width="760px">
          <div class="trend_box" v-if="avgTrendData.length > 0">
            <svg class="trend_svg" viewBox="0 0 680 300" preserveAspectRatio="xMidYMid meet">
              <!-- 网格线与纵轴刻度 -->
              <g v-for="(gv, gi) in avgTrendGrid" :key="'grid' + gi">
                <line :x1="60" :y1="gv.y" :x2="650" :y2="gv.y" stroke="#EBEEF5" stroke-width="1"></line>
                <text :x="50" :y="gv.y + 4" text-anchor="end" font-size="12" fill="#909399">{{gv.label}}</text>
              </g>
              <!-- 折线 -->
              <polyline
                :points="avgTrendPoints"
                fill="none"
                stroke="#409EFF"
                stroke-width="2.5"
                stroke-linejoin="round"
                stroke-linecap="round"></polyline>
              <!-- 数据点与数值 -->
              <g v-for="(p, pi) in avgTrendData" :key="'pt' + pi">
                <circle :cx="p.x" :cy="p.y" r="4" fill="#409EFF"></circle>
                <text :x="p.x" :y="p.y - 10" text-anchor="middle" font-size="12" fill="#303133">{{p.score}}</text>
                <text :x="p.x" :y="280" text-anchor="middle" font-size="12" fill="#606266">{{p.label}}</text>
                <title>{{p.name}}：平均分 {{p.score}}</title>
              </g>
              <!-- 横轴基线 -->
              <line :x1="60" :y1="250" :x2="650" :y2="250" stroke="#DCDFE6" stroke-width="1"></line>
            </svg>
          </div>
          <div v-else style="text-align:center;padding:40px 0;color:#909399;">暂无作业数据，无法生成走势图</div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="avgTrendShow = false">关 闭</el-button>
          </span>
        </el-dialog>

        <!-- 新增题库作业 -->
        <el-dialog
          title="新增题库作业"
          :visible.sync="homewordk_add_dialog"
          class="dialog_"
          width="900px">
          <HomeworkAdd ref="homeworkAdd"
          :classList="classList"
          v-if="homewordk_add_dialog"
          :homeInfo="homeInfo"
          :courseId="courseId"></HomeworkAdd>
          <span slot="footer" class="dialog-footer">
            <el-button @click="homewordk_add_dialog = false">取 消</el-button>
            <el-button type="primary" @click="homewordkAdd">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 学生小测概览（右侧滑出） -->
        <el-drawer
          title="学生小测概览"
          :visible.sync="overviewShow"
          direction="rtl"
          size="72%"
          custom-class="ov_drawer"
          @open="onOverviewOpen">
          <div class="ov_body" v-loading="overviewLoading" element-loading-text="正在统计数据…">
            <div class="ov_top">
              <el-select
                v-model="overviewSettingId"
                placeholder="请选择小测"
                style="width: 300px;"
                @change="changeOverviewSetting">
                <el-option
                  v-for="item in overviewSettings"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <span class="ov_meta">及格线 {{overviewPassLine}} 分 · 满分 {{overviewTotalScore}} 分</span>
            </div>

            <div class="ov_stats">
              <div class="ov_stat" v-for="item in overviewStats" :key="item.label">
                <span class="ov_stat_lab" :title="item.hint || ''">{{item.label}}</span>
                <span class="ov_stat_num" :style="{color: item.color || '#303133'}">{{item.value}}</span>
              </div>
            </div>

            <div class="ov_main">
              <div class="ov_card ov_chart">
                <div class="ov_card_head">成绩分布</div>
                <div class="ov_chart_box" v-if="overviewDonut.length">
                  <svg viewBox="0 0 380 320" class="ov_svg">
                    <g transform="translate(190,160)">
                      <circle r="68" fill="none" stroke="#F0F2F5" stroke-width="30"></circle>
                      <circle
                        v-for="(seg, si) in overviewDonut"
                        :key="'seg' + si"
                        r="68"
                        fill="none"
                        :stroke="seg.color"
                        stroke-width="30"
                        :stroke-dasharray="seg.dash + ' ' + (donutCircumference - seg.dash)"
                        :stroke-dashoffset="seg.offset"
                        transform="rotate(-90)"></circle>
                      <g v-for="(seg, si) in overviewDonut" :key="'lab' + si">
                        <line
                          :x1="seg.lineX1" :y1="seg.lineY1"
                          :x2="seg.lineX2" :y2="seg.lineY2"
                          :stroke="seg.color" stroke-width="1.5"></line>
                        <text
                          :x="seg.textX" :y="seg.textY"
                          :text-anchor="seg.anchor"
                          font-size="12" fill="#606266">{{seg.name}} {{seg.count}}人</text>
                      </g>
                      <text x="0" y="-4" text-anchor="middle" font-size="24" font-weight="bold" fill="#303133">{{overviewAttended}}</text>
                      <text x="0" y="18" text-anchor="middle" font-size="12" fill="#909399">实考人数</text>
                    </g>
                  </svg>
                </div>
                <div class="ov_empty" v-else>暂无作答数据</div>
                <div class="ov_legend">
                  <span class="ov_legend_item" v-for="(seg, si) in overviewDonut" :key="'lg' + si">
                    <i :style="{background: seg.color}"></i>{{seg.name}}
                  </span>
                </div>
              </div>

              <div class="ov_card ov_rank">
                <div class="ov_card_head">
                  得分率最低题目
                  <span class="ov_card_sub" v-if="lowRateQuestions.length">（共 {{overviewQuestionCount}} 题，按得分率升序）</span>
                </div>
                <div class="ov_q" v-for="(q, qi) in lowRateQuestions" :key="'q' + qi">
                  <span class="ov_q_idx">{{qi + 1}}.</span>
                  <span class="ov_q_stem" :title="q.stem">{{q.stem}}</span>
                  <span class="ov_q_rate">得分率 {{q.rate}}%，{{q.correct}} 人答对</span>
                </div>
                <div class="ov_empty" v-if="!lowRateQuestions.length && !overviewLoading">暂无题目数据</div>
              </div>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
</template>
<script>

import HomeworkAdd from "./HomeworkAdd";	//页面头部
import {getClassInfo} from "@/common/getInfo";	//加载数据
import UploadFiles from "@/components/UploadFiles";	//上传
export default {
  name: 'Homework',
  components: {
  	HomeworkAdd,
    UploadFiles
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      activeName: 'HOMEWORK_QUESTION', //HOMEWORK_QUESTION:作业-题目类型 HOMEWORK_FILE:作业-附件类型
      tableData:[],  //题库作业

      total: 0,
      limit:8,
      page:1,
      tableData_file:[], //附件作业
      currentPage1_file: 1,
      total_file: 0,
      limit_file:8,
      page_file:1,
      homewordk_add_dialog:false, //添加作业show
      homewordk_dialog:false, //提交作业show
      form:{},
      teacherOpenCourseQuestionSettingFileList:[],
      homeInfo:{}, //作业信息  编辑时使用
      time:[],
      classIds:[],
      classList:[],
      analysisInfo:{}, //作业 "HOMEWORK_QUESTION"
      fileAnalysisInfo:{}, //附件作业 "HOMEWORK_FILE"
      // ==================== 课堂小测：数据统计 ====================
      classTest:{
        loading:false,
        progress:"",
        shouldCount:0, //应考人数
        attendedCount:0, //已考人数
        absentCount:0, //未考人数
        passCount:0, //及格人数
        passRate:"0.00" //及格率
      },
      // ==================== 学生小测概览 ====================
      overviewShow:false,
      overviewLoading:false,
      overviewSettingId:"", //当前查看的小测
      overviewSettings:[], //可切换的小测列表
      overviewScores:[], //当前小测的学生成绩明细
      overviewTotalScore:100, //当前小测满分
      overviewPassLine:60, //及格线（折成百分制）
      overviewStats:[], //顶部 7 个指标
      overviewDonut:[], //成绩分布环形图分段
      overviewAttended:0,
      lowRateQuestions:[], //得分率最低题目
      overviewQuestionCount:0,
      scoreWeight:{}, //成绩权重设置（及格线来源）
      scoreWeightLoaded:false,
      scoreListCache:{}, //小测ID -> 学生成绩明细，避免重复请求
      donutCircumference:0, //环形图周长，供模板算 dash
      // ==================== 按小组发布作业 ====================
      pushType:"CLASS", //发布方式 CLASS按班级 GROUP按小组
      groupIds:[], //选中的作业小组（值=小组ID，来自 A2 返回的 groupId；后端未返回 ID 的旧数据回退为组名）
      courseGroups:[], //课程小组摘要 [{name, groupId, studentIds}]，来自课程小组管理保存的 sessionStorage
      // ==================== 作业平均分走势图 ====================
      avgTrendShow:false,
      avgTrendData:[] //[{name, label, score, x, y}]
    }
  },
  created() {
    this.donutCircumference = Math.round(2 * Math.PI * 68 * 100) / 100;
    this.getInfo();
    this.analysis("HOMEWORK_QUESTION");
    this.loadClassTestStat();
    this.loadCourseGroups(); //预载课程小组（A2）：小组作业列表标识的 ID→组名映射用
    getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
  },
  mounted() {

  },
  computed: {
    //走势图折线点集："x1,y1 x2,y2 ..."
    avgTrendPoints() {
      return this.avgTrendData.map(p => p.x + "," + p.y).join(" ");
    },
    //走势图横线网格：满分按 100 分计，每 20 分一条
    avgTrendGrid() {
      let grid = [];
      for (let v = 0; v <= 100; v += 20) {
        grid.push({ label: String(v), y: 250 - v * 2 });
      }
      return grid;
    }
  },
  methods: {
    // ==================== 课堂小测：数据统计 ====================
    pickField(obj, keys, def) { //按优先级取第一个有值的字段，避免写死后端字段名
      if (!obj) return def;
      for (let i = 0; i < keys.length; i++) {
        let v = obj[keys[i]];
        if (v !== undefined && v !== null && v !== "") return v;
      }
      return def;
    },
    settingIdOf(setting) {
      return this.pickField(setting, ["teacherOpenCourseQuestionSettingId", "id", "questionSettingId"], "");
    },
    settingNameOf(setting) {
      return this.pickField(setting, ["teacherOpenCourseQuestionSettingName", "name", "questionSettingName"], "");
    },
    totalScoreOf(setting) { //小测满分，取不到按百分制
      let t = Number(this.pickField(setting, [
        "questionSettingTotalScore",
        "teacherOpenCourseQuestionSettingTotalScore",
        "totalScore",
        "questionTotalScore",
        "questionSettingScore"
      ], 0));
      return t > 0 ? t : 100;
    },
    studentKeyOf(row) {
      return String(this.pickField(row, ["studentId", "personId", "studentSn", "studentName"], "-"));
    },
    scoreOf(row) {
      let n = Number(this.pickField(row, [
        "sumStudentScore",
        "questionLogSummaryStudentTotalScore",
        "studentTotalScore",
        "studentScore",
        "score"
      ], 0));
      return isNaN(n) ? 0 : n;
    },
    isAnswered(row) { //是否真的作答：优先看交卷标记，其次看分数
      if (!row) return false;
      let id = this.pickField(row, ["questionLogSummaryId", "teacherOpenCourseQuestionLogSummaryId"], "");
      let finish = this.pickField(row, [
        "finishTime",
        "questionLogSummaryFinishTime",
        "questionLogSummaryAddTime",
        "questionLogSummarySubmitTime"
      ], "");
      if (id || finish) return true;
      return this.scoreOf(row) > 0;
    },
    isPassRow(row, pct, passLine) { //后端口径优先，取不到再按及格线折算
      let flag = this.pickField(row, ["questionLogSummaryIsPass", "isPass"], null);
      if (flag !== null) {
        return flag === true || flag === 1 || flag === "1" || flag === "true" || flag === "Y" || flag === "及格";
      }
      return pct >= passLine;
    },
    fmtScore(n) {
      let v = Number(n);
      if (isNaN(v)) v = 0;
      return Math.round(v * 10) / 10;
    },
    fetchStudentTotal() { //课程学生总数 = 应考人数
      return this.$post("/api/teacherOpenCourseMergeStudent/getPageList.do", {
        limit: 1,
        page: 1,
        teacherOpenCourseId: this.courseId
      }).then((ret) => (ret && ret.code == 0) ? Number(ret.count || 0) : 0);
    },
    fetchSettingPage() { //全部课堂小测
      return this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do", {
        limit: 999,
        page: 1,
        teacherOpenCourseId: this.courseId,
        teacherOpenCourseQuestionSettingType: "HOMEWORK_QUESTION"
      }).then((ret) => (ret && ret.code == 0) ? (ret.data || []) : []);
    },
    fetchSettingScores(settingId) { //某个小测下全部学生的成绩明细
      if (this.scoreListCache[settingId]) return Promise.resolve(this.scoreListCache[settingId]);
      return this.$post("/api/teacherOpenCourseQuestionLog/studentScoreList.do", {
        limit: 9999,
        page: 1,
        teacherOpenCourseQuestionSettingId: settingId,
        teacherOpenCourseQuestionLogStatus: 2
      }).then((ret) => {
        let rows = (ret && ret.code == 0) ? (ret.data || []) : [];
        this.scoreListCache[settingId] = rows;
        return rows;
      });
    },
    loadClassTestStat() { //课程级小测统计：应考 / 未考 / 已考 / 及格 / 及格率
      if (this.classTest.loading) return;
      this.classTest.loading = true;
      this.classTest.progress = "";
      let settings = [];
      let studentTotal = 0;
      let attended = {};
      let passed = {};
      this.fetchStudentTotal().catch(() => 0).then((total) => {
        studentTotal = total || 0;
        return this.fetchSettingPage().catch(() => []);
      }).then((list) => {
        settings = list || [];
        if (!settings.length) {
          this.applyClassTestStat(studentTotal, attended, passed);
          return null;
        }
        return this.loadScoreWeight().then(() => {
          let thresholds = this.resolveThresholds();
          let done = 0;
          let queue = settings.slice();
          const step = () => new Promise((resolve) => {
            let setting = queue.shift();
            if (!setting) {
              resolve();
              return;
            }
            let id = this.settingIdOf(setting);
            let totalScore = this.totalScoreOf(setting);
            let scale = totalScore > 0 ? 100 / totalScore : 1;
            this.fetchSettingScores(id).catch(() => []).then((rows) => {
              (rows || []).forEach((row) => {
                if (!this.isAnswered(row)) return;
                let key = this.studentKeyOf(row);
                attended[key] = 1;
                let pct = this.scoreOf(row) * scale;
                if (this.isPassRow(row, pct, thresholds.pass)) passed[key] = 1;
              });
              done++;
              this.classTest.progress = done + "/" + settings.length;
              resolve();
            });
          });
          //3 个并发，避免小测多时排长队
          let workers = [];
          for (let i = 0; i < Math.min(3, settings.length); i++) workers.push(step());
          return Promise.all(workers);
        }).then(() => {
          this.applyClassTestStat(studentTotal, attended, passed);
        });
      }).catch(() => {
        this.classTest.loading = false;
        this.classTest.progress = "";
      });
    },
    applyClassTestStat(studentTotal, attended, passed) {
      let attendedCount = Object.keys(attended || {}).length;
      let passCount = Object.keys(passed || {}).length;
      let should = studentTotal > 0 ? studentTotal : attendedCount;
      if (should < attendedCount) should = attendedCount;
      this.classTest.shouldCount = should;
      this.classTest.attendedCount = attendedCount;
      this.classTest.absentCount = Math.max(0, should - attendedCount);
      this.classTest.passCount = passCount;
      //及格率按「及格人数 / 应考人数」计，与页面上的应考口径保持一致
      this.classTest.passRate = should > 0 ? (passCount / should * 100).toFixed(2) : "0.00";
      this.classTest.loading = false;
      this.classTest.progress = "";
    },
    loadScoreWeight() { //成绩权重设置里带有及格线（二分法/等级法/字母法）
      if (this.scoreWeightLoaded) return Promise.resolve(this.scoreWeight);
      return this.$get("/api/teacherOpenCourseScoreWeight/getInfo.do", {
        teacherOpenCourseId: this.courseId
      }).then((ret) => {
        this.scoreWeight = (ret && ret.code == 0 && ret.data) ? ret.data : {};
        this.scoreWeightLoaded = true;
        return this.scoreWeight;
      }).catch(() => {
        this.scoreWeight = {};
        this.scoreWeightLoaded = true;
        return {};
      });
    },
    resolveThresholds() { //换算成百分制的优秀/良好/及格线
      let w = this.scoreWeight || {};
      let mode = String(w.resultStatusSetting || "1");
      let pass = 60, good = 80, excellent = 90;
      if (mode === "1") {
        pass = Number(w.dichotomyScore || 60);
      } else if (mode === "2") {
        pass = Number(w.passScore || 60);
        good = Number(w.goodScore || 80);
        excellent = Number(w.excellentScore || 90);
      } else {
        pass = Number(w.letterdScore || 60);
      }
      if (!pass || pass <= 0) pass = 60;
      if (!good || good < pass) good = Math.max(pass, 80);
      if (!excellent || excellent < good) excellent = Math.max(good, 90);
      return { pass: pass, good: good, excellent: excellent };
    },
    // ==================== 学生小测概览 ====================
    openOverview() {
      this.overviewShow = true;
    },
    onOverviewOpen() {
      this.overviewLoading = true;
      this.lowRateQuestions = [];
      this.overviewQuestionCount = 0;
      this.loadScoreWeight().then(() => this.fetchSettingPage().catch(() => [])).then((list) => {
        this.overviewSettings = (list || []).map((s) => ({
          id: this.settingIdOf(s),
          name: this.settingNameOf(s),
          raw: s
        }));
        if (!this.overviewSettings.length) {
          this.overviewSettingId = "";
          this.overviewStats = [];
          this.overviewDonut = [];
          this.overviewLoading = false;
          return;
        }
        let exists = this.overviewSettings.some((s) => String(s.id) === String(this.overviewSettingId));
        if (!exists) this.overviewSettingId = this.overviewSettings[0].id;
        this.buildOverview();
      }).catch(() => {
        this.overviewLoading = false;
      });
    },
    changeOverviewSetting() {
      this.buildOverview();
    },
    buildOverview() {
      let setting = this.overviewSettings.filter((s) => String(s.id) === String(this.overviewSettingId))[0];
      if (!setting) return;
      this.overviewLoading = true;
      this.lowRateQuestions = [];
      this.overviewQuestionCount = 0;
      let thresholds = this.resolveThresholds();
      this.overviewPassLine = thresholds.pass;
      this.overviewTotalScore = this.totalScoreOf(setting.raw);
      Promise.all([
        this.fetchSettingScores(this.overviewSettingId).catch(() => []),
        this.fetchStudentTotal().catch(() => 0)
      ]).then((res) => {
        this.calcOverview(res[0] || [], res[1] || 0, thresholds);
        this.loadLowRateQuestions(this.overviewSettingId);
      }).catch(() => {
        this.overviewLoading = false;
      });
    },
    calcOverview(rows, studentTotal, thresholds) {
      let totalScore = this.overviewTotalScore > 0 ? this.overviewTotalScore : 100;
      let scale = 100 / totalScore;
      let seen = {};
      let scores = [];
      (rows || []).forEach((row) => {
        if (!this.isAnswered(row)) return;
        let key = this.studentKeyOf(row);
        if (seen[key]) return;
        seen[key] = 1;
        let raw = this.scoreOf(row);
        let pct = raw * scale;
        scores.push({
          raw: raw,
          pct: pct,
          pass: this.isPassRow(row, pct, thresholds.pass)
        });
      });
      let attended = scores.length;
      let should = studentTotal > 0 ? studentTotal : attended;
      if (should < attended) should = attended;
      let passCount = scores.filter((s) => s.pass).length;
      let nums = scores.map((s) => s.raw);
      let max = nums.length ? Math.max.apply(null, nums) : 0;
      let min = nums.length ? Math.min.apply(null, nums) : 0;
      let sum = nums.reduce((a, b) => a + b, 0);
      let avg = nums.length ? sum / nums.length : 0;
      this.overviewAttended = attended;
      this.overviewStats = [
        { label: "应考人数", value: should, hint: "一门课程的学生总数，不受本小测班级限制" },
        { label: "实考人数", value: attended },
        { label: "及格人数", value: passCount, color: "#67C23A" },
        { label: "不及格人数", value: attended - passCount, color: "#F56C6C" },
        { label: "最高分", value: this.fmtScore(max) },
        { label: "最低分", value: this.fmtScore(min) },
        { label: "平均分", value: this.fmtScore(avg) }
      ];
      let buckets = [
        { name: "优秀", color: "#409EFF", count: 0 },
        { name: "良好", color: "#67C23A", count: 0 },
        { name: "及格", color: "#E6A23C", count: 0 },
        { name: "不及格", color: "#F56C6C", count: 0 }
      ];
      scores.forEach((s) => {
        if (s.pct >= thresholds.excellent) buckets[0].count++;
        else if (s.pct >= thresholds.good) buckets[1].count++;
        else if (s.pct >= thresholds.pass) buckets[2].count++;
        else buckets[3].count++;
      });
      this.overviewDonut = this.buildDonut(buckets, attended);
      this.overviewLoading = false;
    },
    buildDonut(buckets, total) { //用 SVG 画环形图，不引入图表库
      let circumference = this.donutCircumference;
      let out = [];
      let acc = 0;
      (buckets || []).forEach((b) => {
        if (!b.count) return;
        let ratio = total > 0 ? b.count / total : 0;
        let dash = ratio * circumference;
        let mid = (acc + ratio / 2) * 360 - 90;
        let rad = mid * Math.PI / 180;
        let cos = Math.cos(rad);
        let x1 = cos * 86, y1 = Math.sin(rad) * 86;
        let x2 = cos * 100, y2 = Math.sin(rad) * 100;
        let x3 = cos * 106, y3 = Math.sin(rad) * 106;
        let anchor = cos > 0.15 ? "start" : (cos < -0.15 ? "end" : "middle");
        out.push({
          name: b.name,
          color: b.color,
          count: b.count,
          dash: Math.round(dash * 100) / 100,
          offset: Math.round(-acc * circumference * 100) / 100,
          lineX1: Math.round(x1 * 10) / 10,
          lineY1: Math.round(y1 * 10) / 10,
          lineX2: Math.round(x2 * 10) / 10,
          lineY2: Math.round(y2 * 10) / 10,
          textX: Math.round(x3 * 10) / 10,
          textY: Math.round((y3 + 4) * 10) / 10,
          anchor: anchor
        });
        acc += ratio;
      });
      return out;
    },
    loadLowRateQuestions(settingId) { //按题目聚合得分率，取最低的几道
      this.$post("/api/teacherOpenCourseQuestionLog/list.do?questionSettingType=HOMEWORK_QUESTION", {
        limit: 9999,
        page: 1,
        teacherOpenCourseQuestionSettingId: settingId,
        questionSettingType: "HOMEWORK_QUESTION"
      }).then((ret) => {
        if (!ret || ret.code != 0) return;
        let rows = ret.data || [];
        let map = {};
        let order = [];
        rows.forEach((row) => {
          let key = String(this.pickField(row, ["questionId", "generalQuestionId", "questionCode"], row.questionStem || ""));
          if (!map[key]) {
            map[key] = {
              stem: this.plainText(row.questionStem),
              full: Number(this.pickField(row, ["questionScore", "questionTotalScore"], 0)) || 0,
              got: 0,
              correct: 0,
              people: 0,
              students: {}
            };
            order.push(key);
          }
          let item = map[key];
          let sid = this.studentKeyOf(row);
          if (item.students[sid]) return; //同一学生同一题只算一次
          item.students[sid] = 1;
          let full = Number(this.pickField(row, ["questionScore", "questionTotalScore"], 0)) || 0;
          if (full > 0) item.full = full;
          let got = Number(this.pickField(row, ["studentScore", "questionLogStudentScore"], 0)) || 0;
          item.got += got;
          item.people++;
          if (item.full > 0 && got >= item.full) item.correct++;
        });
        let list = order.map((k) => map[k]).filter((q) => q.people > 0 && q.full > 0);
        list.forEach((q) => {
          q.rate = Math.round(q.got / (q.full * q.people) * 1000) / 10;
          if (q.rate > 100) q.rate = 100;
          if (q.rate < 0) q.rate = 0;
        });
        this.overviewQuestionCount = list.length;
        list.sort((a, b) => a.rate - b.rate);
        this.lowRateQuestions = list.slice(0, 6);
      }).catch(() => {});
    },
    plainText(html) {
      let s = String(html || "")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      return s.length > 68 ? s.substring(0, 68) + "…" : (s || "（无题干）");
    },
    handleClick(){
      if(this.tableData_file.length <= 0 || this.tableData.length <= 0){
        this.getInfo();
      }
      if(this.activeName == "HOMEWORK_FILE" && Object.keys(this.fileAnalysisInfo).length <= 0){
        this.analysis("HOMEWORK_FILE");
      }
      if(this.activeName == "HOMEWORK_QUESTION" && Object.keys(this.analysisInfo).length <= 0){
        this.analysis("HOMEWORK_QUESTION");
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleSizeChange_file(val) {
      console.log(`每页 ${val} 条`);
      this.limit_file = val;
      this.getInfo();
    },
    handleCurrentChange_file(val) {
      console.log(`当前页: ${val}`);
      this.page_file = val;
      this.getInfo_file();
    },
    analysis(type){
      this.$post("/api/teacherOpenCourseQuestionSetting/analysisTotal.do",{teacherOpenCourseId:this.courseId,questionSettingType:type}).then((ret) =>{
        if(ret.code == 0){
          if(type == "HOMEWORK_QUESTION"){
            this.analysisInfo = ret.data;
          }else{
            this.fileAnalysisInfo = ret.data;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseQuestionSettingType:this.activeName
      }
      if(this.activeName == "HOMEWORK_FILE"){ //HOMEWORK_QUESTION:作业-题目类型 HOMEWORK_FILE:作业-附件类型
        param.limit = this.limit_file;
        param.page = this.page_file;
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          if(this.activeName == "HOMEWORK_FILE"){
            this.total_file = Number(ret.count);
            this.tableData_file = ret.data;
          }else{
            this.total = Number(ret.count);
            this.tableData = ret.data;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startHomework(item,type){ //开始作业 type:1作业 2:详情
      this.$router.push({name:'Exercises',query:{type:type,item:item}});
    },
    addHomeworkInfo(){ //新增作业对话框
      this.homeInfo = {};
      this.homewordk_add_dialog = true;
    },
    editHomeworkInfo(item){
      this.homeInfo = item;
      this.homewordk_add_dialog = true;
    },
    exportInfo(type){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let xlsxName = "题库作业";
        if(type == "HOMEWORK_FILE"){
          xlsxName = "附件作业";
        }
        this.$downLoadFile('/api/teacherOpenCourseQuestionSetting/exportPageList.do?teacherOpenCourseQuestionSettingType='+type+"&teacherOpenCourseId="+this.courseId, xlsxName +`-导出${new Date().toLocaleString()}.xlsx`);
        //this.$message({type: 'success',message: '导出成功！'});
      }).catch((e) => {
        console.log(e)
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    releaseInfo(item,pushStatus){ //发布信息
      let param = {
        ids:item.teacherOpenCourseQuestionSettingId,
        pushStatus:pushStatus // 发布 PUSH 未发布UN_PUSH
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/editPushStatus.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({type: 'success',message: '发布成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    homeworkScore(item){ //作业成绩
      this.$router.push({name:'HomeworkScore',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:item.teacherOpenCourseId}});
    },
    homeworkDetails(item){ //作业详情
      this.$router.push({name:'THomeworkDetails',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:item.teacherOpenCourseId}});
    },
    delInfo(item){ //删除
      this.$confirm('是否确定删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/api/teacherOpenCourseQuestionSetting/delete.do",{ids:item.teacherOpenCourseQuestionSettingId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功！'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    addHomeworkEnclosure(item){ //添加附件作业
      this.form = {};
      this.teacherOpenCourseQuestionSettingFileList = [];
      this.time = [];
      this.classIds = [];
      this.pushType = "CLASS";
      this.groupIds = [];
      this.loadCourseGroups();
      if(!this.$isEmpty(item)){ //item不为空表示修改
        this.form = {
          teacherOpenCourseQuestionSettingName:item.teacherOpenCourseQuestionSettingName,
          teacherOpenCourseQuestionSettingId:item.teacherOpenCourseQuestionSettingId,
          teacherOpenCourseQuestionSettingRequire:item.teacherOpenCourseQuestionSettingRequire
        }
        //作业
        if(!this.$isEmpty(item.teacherOpenCourseQuestionStartTime) && !this.$isEmpty(item.teacherOpenCourseQuestionEndTime)){
          this.time = [item.teacherOpenCourseQuestionStartTime,item.teacherOpenCourseQuestionEndTime];
        }
        //班级
        if(!this.$isEmpty(item.teacherOpenCourseQuestionSettingSchoolClassIds)){
          this.classIds = item.teacherOpenCourseQuestionSettingSchoolClassIds.split(",");
        }
        //发布方式与小组（后端字段就绪后自动回显）
        if(item.teacherOpenCourseQuestionSettingPushType == "GROUP"){
          this.pushType = "GROUP";
          if(!this.$isEmpty(item.teacherOpenCourseQuestionSettingGroupIds)){
            this.groupIds = item.teacherOpenCourseQuestionSettingGroupIds.split(",");
          }
        }
        //附件
        if(!this.$isEmpty(item.teacherOpenCourseQuestionSettingFile)){
          this.teacherOpenCourseQuestionSettingFileList = JSON.parse(item.teacherOpenCourseQuestionSettingFile);
        }
      }
      this.homewordk_dialog = true;
    },
    loadCourseGroups(cb){ //读取课程小组：优先调后端 A2 查询接口（班级页没保存过分组也有数据），失败回退 sessionStorage 摘要；cb 在数据就绪后回调
      this.$post("/api/teacherOpenCourseMergeStudentGroup/getList.do", {
        teacherOpenCourseId: this.courseId
      }).then(ret => {
        if (ret.code == 0) {
          this.courseGroups = (ret.data || []).map(g => {
            return {
              name: g.groupName || "",
              groupId: g.groupId || "",
              studentIds: (g.students || []).map(s => String(s.studentId))
            };
          });
        } else {
          this.loadCourseGroupsFromCache();
        }
        if (cb) cb();
      }).catch(() => {
        this.loadCourseGroupsFromCache();
        if (cb) cb();
      });
    },
    loadCourseGroupsFromCache(){ //回退：读班级页保存到 sessionStorage 的小组摘要
      try {
        let v = this.$ls.get(this.$getKeyInfo("courseGroups_" + this.courseId));
        this.courseGroups = Array.isArray(v) ? v : [];
      } catch (e) {
        this.courseGroups = [];
      }
    },
    groupNamesText(row){ //小组作业的组名展示：GroupIds 为小组 ID（A2 返回的 groupId），映射成组名；旧数据存组名时直接匹配
      if(this.$isEmpty(row.teacherOpenCourseQuestionSettingGroupIds)) return "";
      return row.teacherOpenCourseQuestionSettingGroupIds.split(",").map(val => {
        let g = this.courseGroups.find(x => (x.groupId && x.groupId === val) || x.name === val);
        if (g) return g.name;
        return this.courseGroups.length ? "已失效小组" : val; //分组被重排/删除后旧 ID 匹配不上
      }).join("、");
    },
    onPushTypeChange(val){ //切换发布方式：按小组时校验是否已分组（小组查询是异步的，就绪后再判断）
      if (val == "GROUP") {
        this.loadCourseGroups(() => {
          if (this.courseGroups.length === 0) {
            this.$message({ message: "当前未分组，请先进行分组", type: "warning" });
            this.pushType = "CLASS";
          }
        });
      }
    },
    exportHomeworkScore(item){ //导出该次课堂小测的成绩明细（xlsx：学号/姓名/班级/评语/分数）
      this.$downLoadFile('/api/teacherOpenCourseQuestionSetting/exportHomeworkScore.do?teacherOpenCourseQuestionSettingId=' + item.teacherOpenCourseQuestionSettingId,
        item.teacherOpenCourseQuestionSettingName + '-成绩明细-' + this.fileTime() + '.xlsx');
    },
    fileTime(){ //文件名用时间戳（避免 / : 等非法字符导致文件名被截断）
      let d = new Date();
      let p = (n) => ('0' + n).slice(-2);
      return '' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds());
    },
    exportHomeworkFile(item){ //导出该次作业的全部学生作业（后端接口待实现，路径已按约定占位）
      this.$confirm('是否确定导出该次作业的全部学生作业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downLoadFile('/api/teacherOpenCourseQuestionSetting/exportHomeworkFile.do?teacherOpenCourseQuestionSettingId=' + item.teacherOpenCourseQuestionSettingId,
          item.teacherOpenCourseQuestionSettingName + `-学生作业${new Date().toLocaleString()}.zip`);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    openAvgTrend(){ //作业平均分走势图：拉取全部附件作业，按列表顺序取平均分
      this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do", {
        limit: 999,
        page: 1,
        teacherOpenCourseId: this.courseId,
        teacherOpenCourseQuestionSettingType: "HOMEWORK_FILE"
      }).then((ret) => {
        if (ret.code == 0) {
          let rows = ret.data || [];
          let list = rows.map((row, i) => {
            let score = Number(row.avgScore);
            if (isNaN(score)) score = 0;
            return {
              name: row.teacherOpenCourseQuestionSettingName || ("作业" + (i + 1)),
              label: "作业" + (i + 1),
              score: Math.round(score * 100) / 100
            };
          });
          if (list.length === 0) {
            this.avgTrendData = [];
            this.avgTrendShow = true;
            return;
          }
          //坐标换算：x 在 60~650 均分，y = 250 - score*2（满分100）
          let step = list.length > 1 ? (650 - 60) / (list.length - 1) : 0;
          list.forEach((p, i) => {
            p.x = 60 + i * step;
            p.y = 250 - Math.max(0, Math.min(100, p.score)) * 2;
          });
          this.avgTrendData = list;
          this.avgTrendShow = true;
        } else {
          this.$message({ message: ret.msg, type: 'error' });
        }
      });
    },
    submitHomeworkGroups(){ //按小组发布时组装小组字段，返回 false 表示校验不通过
      if (this.pushType == "GROUP") {
        if (this.$isEmpty(this.groupIds)) {
          this.$message({ message: '请选择作业小组！', type: 'warning' });
          return false;
        }
        this.form.teacherOpenCourseQuestionSettingPushType = "GROUP";
        this.form.teacherOpenCourseQuestionSettingGroupIds = this.groupIds.join(",");
      } else {
        this.form.teacherOpenCourseQuestionSettingPushType = "CLASS";
      }
      return true;
    },
    submitHomewordk(){
      if(this.$isEmpty(this.form.teacherOpenCourseQuestionSettingName)){
        this.$message({message: '请输入作业名称！',type: 'warning'});
        return;
      }
      if(this.pushType == "GROUP"){ //按小组发布：校验小组，班级选填
        if(!this.submitHomeworkGroups()) return;
        this.form.teacherOpenCourseQuestionSettingSchoolClassIds = this.classIds.join(",");
      }else{ //按班级发布：原有逻辑
        if(this.$isEmpty(this.classIds)){
          this.$message({message: '请选择作业班级！',type: 'warning'});
          return;
        }else{
          this.form.teacherOpenCourseQuestionSettingSchoolClassIds = this.classIds.join(",");
        }
        this.form.teacherOpenCourseQuestionSettingPushType = "CLASS";
      }
      if(this.time.length <= 0){
        this.$message({message: '请选择作业时间！',type: 'warning'});
        return;
      }else{
        this.form.teacherOpenCourseQuestionStartTime = this.time[0];
        this.form.teacherOpenCourseQuestionEndTime = this.time[1];
      }
      if(this.$isEmpty(this.form.teacherOpenCourseQuestionSettingRequire)){
        this.$message({message: '请输入作业要求！',type: 'warning'});
        return;
      }
      if(this.teacherOpenCourseQuestionSettingFileList.length <= 0){
        this.$message({message: '请上传作业附件！',type: 'warning'});
        return;
      }
      this.form.teacherOpenCourseQuestionSettingFile = JSON.stringify(this.teacherOpenCourseQuestionSettingFileList);
      this.submitInfo(this.form);
    },
    HomeworkFJScore(item){ //作业附件详情
      this.$router.push({name:'HomeworkFJScore',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:item.teacherOpenCourseId}});
    },
    practicalReview(item){ //评阅
      this.$router.push({name:'HomeworkPracticalReview',query:{courseId:this.courseId,id:item.teacherOpenCourseQuestionSettingId}});
    },
    homewordkAdd(){ //保存新增题库信息（课堂小测只按班级发布，小组发布仅附件作业支持）
      let addForm = this.$refs.homeworkAdd.form; //获取新增题库数据
      let time = this.$refs.homeworkAdd.time; //获取新增题库数据
      let classIds = this.$refs.homeworkAdd.classIds; //获取新增题库数据
      if(this.$isEmpty(addForm.teacherOpenCourseQuestionSettingName)){
        this.$message({message: '请输入作业名称！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(classIds)){
        this.$message({message: '请选择作业班级！',type: 'warning'});
        return;
      }else{
        addForm.teacherOpenCourseQuestionSettingSchoolClassIds = classIds.join(",");
      }
      addForm.teacherOpenCourseQuestionSettingPushType = "CLASS";
      if(time.length <= 0){
        this.$message({message: '请选择作业时间！',type: 'warning'});
        return;
      }else{
        addForm.teacherOpenCourseQuestionStartTime = time[0];
        addForm.teacherOpenCourseQuestionEndTime = time[1];
      }
      if(this.$isEmpty(addForm.teacherOpenCourseQuestionSettingDoCount)){
        this.$message({message: '请输入作业次数！',type: 'warning'});
        return;
      }
      let questionSettingOptions = this.$refs.homeworkAdd.questionSettingOptions; //获取新增题库数据
      //关联了考试时题目由后端从考试原样复制，无需（也不能）手动设置题目
      if(this.$isEmpty(addForm.teacherOpenCourseQuestionSettingRelatedExamId)){
        if(this.$isEmpty(questionSettingOptions)){
          this.$message({message: '请设置题目！',type: 'warning'});
          return;
        }
      }
      // addForm.questionSettingOptions = JSON.stringify(questionSettingOptions);
      addForm.questionSettingOptions = questionSettingOptions;
      this.submitInfo(addForm);
    },
    submitInfo(addForm){
      addForm.teacherOpenCourseQuestionSettingType = this.activeName; //作业类型
      //课堂小测走新增接口 addClassTestByType.do（支持关联考试复制题目）；附件作业仍走原接口
      //类型说明：本页「课堂小测」列表按 HOMEWORK_QUESTION 过滤，故这里仍传 HOMEWORK_QUESTION；
      //若后端改用新增枚举 CLASS_TEST，需分页接口同步返回该类型，否则新建的小测在列表里查不到
      let url = (this.activeName == 'HOMEWORK_QUESTION')
        ? "/api/teacherOpenCourseQuestionSetting/addClassTestByType.do"
        : "/api/teacherOpenCourseQuestionSetting/addQuestionByType.do";
      addForm.teacherOpenCourseId = this.courseId;
      this.$postJSON(url, addForm )
        .then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '提交成功！'});
            if(this.activeName == 'HOMEWORK_QUESTION'){//HOMEWORK_QUESTION:作业-题目类型 HOMEWORK_FILE:作业-附件类型
              this.homewordk_add_dialog = false;
            }else{
              this.homewordk_dialog = false;
            }
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
      });
    },
    infoSuccess(file){ //上传成功回调
      this.teacherOpenCourseQuestionSettingFileList = [];
      for(let i in file){
        this.teacherOpenCourseQuestionSettingFileList.push(
        {
          fileName:file[i].name,
          fileUrl:file[i].url,
        });
      }
    },downLoadInfo(item){ //下载
      let list = JSON.parse(item.teacherOpenCourseQuestionSettingFile);
      this.$downLoadFile(list[0].fileUrl,list[0].fileName);
    }
  }
};
</script>
<style  lang="less">
  .course_Homework{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .el-tabs__nav-wrap::after{
        background-color:white;
      }
      .user_discuss_img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .tl_list{
      border-bottom: 1px solid #DEDEDE;padding: 20px 20px 20px 0;
    }
    .tl_list:last-child{
      border-bottom:none;
    }
    .trend_box{
      padding: 10px 0;
      .trend_svg{
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .el-form-item__label{
      width: 100px !important;
    }
    .el-form-item__content{
      margin-left: 100px !important;
    }
    .el-form-item{
      margin-bottom: 10px !important;
    }
    // ==================== 课堂小测：工具栏与统计 ====================
    .ct_head{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .ct_tools{
        flex: none;
      }
      .ct_stat{
        flex: 1;
        min-width: 320px;
        margin-left: 18px;
        font-size: 13px;
        color: #606266;
        .ct_title{
          color: #909399;
        }
        .ct_item{
          margin-right: 20px;
          white-space: nowrap;
          b{
            margin-left: 4px;
            font-size: 16px;
            font-weight: bold;
            color: #303133;
          }
        }
        .ct_warn b{ color: #E6A23C; }
        .ct_blue b{ color: #409EFF; }
        .ct_green b{ color: #67C23A; }
        .ct_red b{ color: #F56C6C; }
        .ct_loading{
          margin-left: 4px;
          font-size: 12px;
          color: #909399;
        }
      }
      .ct_overview{
        flex: none;
        margin-left: 10px;
      }
    }
  }

  /* ==================== 学生小测概览（右侧抽屉） ==================== */
  .ov_drawer{
    .el-drawer__header{
      margin-bottom: 0;
      padding: 16px 20px;
      border-bottom: 1px solid #EBEEF5;
      color: #303133;
      font-size: 16px;
      font-weight: bold;
    }
    .el-drawer__body{
      padding: 0;
      overflow: auto;
      background-color: #F5F7FA;
    }
  }
  .ov_body{
    padding: 18px 20px 24px;
    min-height: 100%;
    .ov_top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 14px;
      .ov_meta{
        font-size: 13px;
        color: #909399;
      }
    }
    .ov_stats{
      display: flex;
      margin-bottom: 16px;
      background-color: #ffffff;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      overflow: hidden;
      .ov_stat{
        flex: 1;
        padding: 14px 6px;
        text-align: center;
        border-right: 1px solid #F2F4F7;
        &:last-child{
          border-right: none;
        }
        .ov_stat_lab{
          display: block;
          font-size: 12px;
          color: #909399;
          line-height: 18px;
        }
        .ov_stat_num{
          display: block;
          font-size: 22px;
          font-weight: bold;
          line-height: 30px;
          color: #303133;
        }
      }
    }
    .ov_main{
      display: grid;
      grid-template-columns: minmax(360px, 42%) 1fr;
      gap: 16px;
      align-items: stretch;
    }
    .ov_card{
      padding: 14px 16px 18px;
      background-color: #ffffff;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      .ov_card_head{
        padding-bottom: 10px;
        margin-bottom: 12px;
        border-bottom: 1px solid #F2F4F7;
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        .ov_card_sub{
          font-weight: normal;
          font-size: 12px;
          color: #909399;
        }
      }
    }
    .ov_chart_box{
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .ov_svg{
      display: block;
      width: 100%;
      max-width: 440px;
      height: auto;
    }
    .ov_legend{
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 6px;
      .ov_legend_item{
        display: flex;
        align-items: center;
        margin: 0 10px;
        font-size: 12px;
        color: #606266;
        i{
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-right: 5px;
          border-radius: 2px;
        }
      }
    }
    .ov_q{
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
      border-bottom: 1px dashed #F0F2F5;
      font-size: 13px;
      line-height: 20px;
      &:last-child{
        border-bottom: none;
      }
      .ov_q_idx{
        flex: none;
        width: 20px;
        color: #909399;
      }
      .ov_q_stem{
        flex: 1;
        min-width: 0;
        color: #303133;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .ov_q_rate{
        flex: none;
        margin-left: 12px;
        color: #F56C6C;
        white-space: nowrap;
      }
    }
    .ov_empty{
      padding: 40px 0;
      text-align: center;
      font-size: 13px;
      color: #C0C4CC;
    }
  }
  @media screen and (max-width: 1440px){
    .ov_body{
      .ov_main{
        grid-template-columns: 1fr;
      }
      //窄屏时指标卡只压缩内边距，保持一行 7 个
      .ov_stats .ov_stat{
        padding: 12px 4px;
        .ov_stat_num{
          font-size: 19px;
        }
      }
    }
  }
  /* 操作列：按钮一律并排单行，不换行（换行后行高不齐、视觉割裂） */
  .el-table .op_cell .cell{
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/Homework.vue